import { Directive, OnInit, OnDestroy, ViewContainerRef, booleanAttribute, inject, input } from '@angular/core';
import { Title } from '@angular/platform-browser';

const MAX_TITLE_CHECK_COUNT = 5;

@Directive({
  selector: 'glxy-page-title, [glxyPageTitle]',
  host: {
    class: 'glxy-page-title',
    role: 'heading',
    '[attr.aria-level]': 'ariaLevel()',
  },
})
export class PageTitleDirective implements OnInit, OnDestroy {
  private readonly title = inject(Title);
  private readonly viewContainerRef = inject(ViewContainerRef);

  readonly ariaLevel = input('1');
  readonly updateTabTitle = input(false, { transform: booleanAttribute });

  private checkCount = 0;
  private observer: MutationObserver | null = null;

  ngOnInit(): void {
    if (this.updateTabTitle()) {
      this.updateTitle();
      this.observeTextChanges();
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }

  private observeTextChanges(): void {
    const element = this.getComponent();
    if (!element) {
      return;
    }

    this.observer = new MutationObserver(() => {
      const text = element.innerText?.trim();
      if (text) {
        this.title.setTitle(text);
      }
    });

    this.observer.observe(element, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  private updateTitle(): void {
    const titleText = this.getComponent().innerText || '';
    if (titleText.trim() !== '') {
      this.title.setTitle(titleText);
    } else {
      this.checkCount += 1;
      if (this.checkCount < MAX_TITLE_CHECK_COUNT) {
        window.setTimeout(() => this.updateTitle(), 500);
      }
    }
  }

  private getComponent(): HTMLElement {
    const container = (this.viewContainerRef as any)['_lContainer'][0];
    if (container instanceof HTMLElement) {
      return container;
    }

    const containerName = container.constructor.name;
    const componentName = containerName.split('_')[1];
    return container.filter((x: any) => x && x.constructor.name === componentName)[0];
  }
}
